export const PAGE_RELOAD_REQUEST = "PAGE_RELOAD_REQUEST";
export const PAGE_RELOAD_STOP = "PAGE_RELOAD_STOP";
